import { payment_remark } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    personID: string
  ): Promise<payment_remark.PaymentRemark[]> {
    const url = new URL(`/payment-remark/`, baseURL);
    url.searchParams.set('type', 'PersonID');
    url.searchParams.set('value', personID);
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to fetch payment remark');
    }
  };
}
